import React from "react";
import { Row, Col } from "antd";
import CustomButton from "../../commonComponents/button";
import CustomDivider from "../../commonComponents/divider";
import { parseUserSettings } from "../../../utils/userHelpers";
import { checkAccessPermission } from "../../../library/helpers";
import { AccessPermissionAction } from "../../../library/constants";
import ReadOnlyField from "./ReadOnlyField";

const CRMInfoTab = ({ user, onEdit }) => {
  const parsedSettings = parseUserSettings(user?.settings);
  const dsAgentSettings = parsedSettings?.DS_AGENT || {};
  const dsUserData = user?.dsUsers?.[0] || user?.dsUser || {};
  const canEditProfile = checkAccessPermission(
    AccessPermissionAction.USER_PROFILE_UPDATE_CRM_INFORMATION
  );

  // Section-wise config: add a field/section here and it renders automatically
  const sections = [
    {
      title: "User Mapping",
      // action: <CustomButton handleClick={onEdit} btnText="Edit" disabled={!canEditProfile} />,
      action: <CustomButton handleClick={onEdit} btnText="Edit" disabled={!canEditProfile} />,
      fields: [
        {
          label: "DS user mapping active/deactive",
          value: dsUserData?.active ? "Active" : "Inactive",
        },
        { label: "DS user ID", value: dsUserData?.dsUserId },
        { label: "DS user name", value: dsUserData?.dsUserName },
      ],
    },
    {
      title: "Call Info",
      fields: [
        { label: "DMS ID", value: dsAgentSettings?.DMS_ID },
        { label: "Inbound ID", value: dsAgentSettings?.INBOUND_ID },
        { label: "Inbound ID 2", value: dsAgentSettings?.INBOUND_ID_2 },
        { label: "Outbound ID", value: dsAgentSettings?.OUTBOUND_ID },
      ],
    },
  ];

  return (
    <div className="pt-8 px-4">
      {sections.map((section, index) => (
        <React.Fragment key={section.title}>
          {index > 0 && <CustomDivider className="!my-6" />}
          <div>
            <div className="flex justify-between items-center mb-8">
              <p className="text-black-88 font-semibold text-base">{section.title}</p>
              {section.action || null}
            </div>

            <Row gutter={[16, 0]} className="max-w-[720px]">
              {section.fields.map(field => (
                <Col key={field.label} xs={24} sm={12}>
                  <ReadOnlyField
                    label={field.label}
                    value={field.value}
                    optional={field.optional}
                  />
                </Col>
              ))}
            </Row>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default CRMInfoTab;
